import { useEffect } from 'react';

const usePageTitle = (title) => {
  useEffect(() => {
    document.title = title
      ? `${title} | G.A ISPAT PVT LTD`
      : 'G.A ISPAT PVT LTD | Trusted Steel Supplier in Kolkata';
  }, [title]);
};

export default usePageTitle;
